module.exports = new __parcel__URL__("not-found.77b45078.svg").toString();